<script>
    import { NotificationModal } from "../../../Components/Common/index.svelte";
    import { apiMethods } from "../../../Services/index.svelte";
    import {
        getEmailValidation,
        showError,
    } from "../../../Utils/utilFunctions.svelte";

    export let accountId;
    export let insurerDetails = {};
    export let isModalOpen = false;
    export let onFinishModify = () => {};
    export let closeModal = () => {};

    $: isEdit = insurerDetails?.hasOwnProperty("id");

    $: isValidEmail = insurerDetails?.email
        ? getEmailValidation(insurerDetails.email)
        : true;

    $: isValidPhone = insurerDetails?.phone
        ? insurerDetails.phone.length >= 6
        : true;

    let isModifying = false;

    const confirmModify = async () => {
        if (isModifying) return;

        isModifying = true;

        if (isEdit) await updateThirdPartyInsurer();
        else await createThirdPartyInsurer();

        isModifying = false;

        closeModifyModal();
    };

    const createThirdPartyInsurer = async () =>
        await apiMethods.postMethod
            .createAccountThirdPartyInsurer({ ...insurerDetails, accountId })
            .then((res) => {
                if (!res || res.error)
                    showError(
                        res.error ??
                            "Failed to create Third Party Insurer, please refresh the page and try again and contact support if the issue persists.",
                    );
                else onFinishModify();
            });

    const updateThirdPartyInsurer = async () =>
        await apiMethods.putMethod
            .updateAccountThirdPartyInsurer(insurerDetails)
            .then((res) => {
                if (!res || res.error)
                    showError(
                        res.error ??
                            "Failed to update Third Party Insurer, please refresh the page and try again and contact support if the issue persists.",
                    );
                else onFinishModify();
            });

    const closeModifyModal = () => closeModal();
</script>

<NotificationModal
    title={`${isEdit ? "Edit" : "Create"} Third Party Insurer`}
    {isModalOpen}
    cancelText="Cancel"
    closeModal={closeModifyModal}
    closeModalFunction={closeModifyModal}
    submitText={`${isEdit ? (isModifying ? "Updating" : "Update") : isModifying ? "Creating" : "Create"}`}
    confirmAction={confirmModify}
>
    <div class="flex flex-col gap-y-2">
        <div class="grid grid-cols-3 gap-x-2 px-2 w-full">
            <p class="flex col-span-1">Payer Name:</p>
            <input
                type="text"
                class="input input-sm input-bordered flex col-span-2"
                autocomplete="off"
                bind:value={insurerDetails.name}
            />
        </div>

        <div class="grid grid-cols-3 gap-x-2 px-2 w-full">
            <p class="flex col-span-1">Payer Email:</p>
            <input
                type="email"
                class="input input-sm input-bordered flex col-span-2"
                autocomplete="off"
                bind:value={insurerDetails.email}
            />
        </div>

        {#if !isValidEmail}
            <div class="grid grid-cols-3 gap-x-2 px-2 w-full">
                <p class="flex col-span-1" />
                <p class="flex col-span-2 text-error">Invalid Email</p>
            </div>
        {/if}

        <div class="grid grid-cols-3 gap-x-2 px-2 w-full">
            <p class="flex col-span-1">Payer Phone No.:</p>
            <input
                type="text"
                class="input input-sm input-bordered flex col-span-2"
                autocomplete="off"
                bind:value={insurerDetails.phone}
            />
        </div>

        {#if !isValidPhone}
            <div class="grid grid-cols-3 gap-x-2 px-2 w-full">
                <p class="flex col-span-1" />
                <p class="flex col-span-2 text-error">Invalid Phone</p>
            </div>
        {/if}

        <div class="grid grid-cols-3 gap-x-2 px-2 w-full">
            <p class="flex col-span-1">Payer Address:</p>
            <input
                type="text"
                class="input input-sm input-bordered flex col-span-2"
                autocomplete="off"
                bind:value={insurerDetails.address}
            />
        </div>

        <div class="grid grid-cols-3 gap-x-2 px-2 w-full">
            <p class="flex col-span-1">Add GST:</p>
            <input
                type="checkbox"
                class="toggle toggle-secondary"
                bind:checked={insurerDetails.addGST}
            />
        </div>
    </div>
</NotificationModal>
